module.exports = __webpack_public_path__ + "static/media/23.45392bb3.mp3";